import { Routes } from '@angular/router';
import { PhotoDetailGuard } from '../../shared/components/photo-detail/photo-detail.guard';
import { environment } from '../../../environments/environment.prod';
import { WebAppComponent } from './web-app.component';

export const webAppRoutes: Routes = [
  {
    path: '', component: WebAppComponent, children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        loadChildren: () => import('../home/home.module').then(m => m.HomeModule),
        data: {
          seo: {
            title: 'GRYF reklamná agentúra | Reklama, ktorú nevypneš',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'GRYF reklamná agentúra | Reklama, ktorú nevypneš' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'about/:id',
        loadChildren: () => import('../about/about.module').then(m => m.AboutModule),
        data: {
          seo: {
            title: 'O nás, firemné údaje | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'O nás, firemné údaje | Gryf' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'products/billboards',
        loadChildren: () => import('../products/billboards/billboards.module').then(m => m.BillboardsModule),
        data: {
          seo: {
            title: 'Billboardy | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'Billboardy | Gryf | Reklama, ktorú nevypneš' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'products/bigboards',
        loadChildren: () => import('../products/bigboards/bigboards.module').then(m => m.BigboardsModule),
        data: {
          seo: {
            title: 'Bigboardy | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'Bigboardy | Gryf | Reklama, ktorú nevypneš' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'products/megaboards',
        loadChildren: () => import('../products/megaboards/megaboards.module').then(m => m.MegaboardsModule),
        data: {
          seo: {
            title: 'Megaboardy | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'Megaboardy | Gryf | Reklama, ktorú nevypneš' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'products/others',
        loadChildren: () => import('../products/others/others.module').then(m => m.OthersModule),
        data: {
          seo: {
            title: 'Reklamné plochy | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'Reklamné plochy | Gryf | Reklama, ktorú nevypneš' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'contacts',
        loadChildren: () => import('../contacts/contacts.module').then(m => m.ContactsModule),
        data: {
          seo: {
            title: 'Kontakty a kontaktný formulár | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'Kontakty a kontaktný formulár | Gryf' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'services/catalogs',
        loadChildren: () => import('../services/services/catalogs/catalogs.module').then(m => m.CatalogsModule),
        data: {
          seo: {
            title: 'Katalógy reklamných predmetov | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              {
                property: 'og:title',
                content: 'Katalógy reklamných predmetov | Gryf',
              },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'services/promotional_items_and_textiles',
        loadChildren: () => import('../services/services/promotional-items/promotional-items.module').then(m => m.PromotionalItemsModule),
        data: {
          seo: {
            title: 'Reklamné predmety a textil | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              {
                property: 'og:title',
                content: 'Reklamné predmety a textil | Gryf | Reklama na mieru'
              },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'services/prints_and_stickers',
        loadChildren: () => import('../services/services/prints-and-stickers/prints-and-stickers.module').then(m => m.PrintsAndStickersModule),
        data: {
          seo: {
            title: 'Tlače a reklamné polepy | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              {
                property: 'og:title',
                content: 'Tlače a reklamné polepy | Gryf'
              },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'services/special_realizations_and_graphics',
        loadChildren: () => import('../services/services/realizations-and-graphics/realizations-and-graphics.module').then(m => m.RealizationsAndGraphicsModule),
        data: {
          seo: {
            title: 'Špeciálne reklamné riešenia a grafika | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              {
                property: 'og:title',
                content: 'Špeciálne reklamné riešenia a grafika | Gryf'
              },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      /*{
        path: 'services/:id',
        loadChildren: () => import('../services/services.module').then(m => m.ServicesModule),
        data: {
          seo: {
            title: 'Reklamné predmety | Grafický a tlačový servis | Gryf | Reklama na mieru',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              {property: 'og:url', content: 'website'},
              {
                property: 'og:title',
                content: 'Reklamné predmety | Grafický a tlačový servis | Gryf | Reklama na mieru'
              },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              {property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg'},
              {property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg'},
            ]
          }
        }
      },*/
      {
        path: 'gallery', canActivate: [ PhotoDetailGuard ],
        loadChildren: () => import('../../shared/components/photo-detail/photo-detail.module').then(m => m.PhotoDetailModule)
      },
      {
        path: 'manual-surface-offer',
        loadChildren: () => import('../surface-offer/manual-surface-offer/manual-surface-offer.module').then(m => m.ManualSurfaceOfferModule),
        data: {
          seo: {
            title: 'Manuál, ako vybrať reklamnú plochu | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'Manuál, ako vybrať reklamnú plochu | Gryf' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'surface-offer',
        loadChildren: () => import('../surface-offer/surface-offer.module').then(m => m.SurfaceOfferModule),
        data: {
          seo: {
            title: 'Online ponuka reklamných plôch | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'Online ponuka reklamných plôch | Gryf | Reklama, ktorú nevypneš' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'surface-offer/detail/:id',
        loadChildren: () => import('../surface-offer/surface-detail/surface-detail.module').then(m => m.SurfaceDetailModule)
      },
      {
        path: 'blog',
        loadChildren: () => import('../blogs/blogs.module').then(m => m.BlogsModule),
        data: {
          seo: {
            title: 'Blog o reklame | Portfólio služieb | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'Blog o reklame | Portfólio služieb | Gryf' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'blog/page/:page',
        loadChildren: () => import('../blogs/blogs.module').then(m => m.BlogsModule)
      },
      {
        path: 'blog/:url',
        loadChildren: () => import('../blog-detail/blog-detail.module').then(m => m.BlogDetailModule)
      },
      {
        path: 'cookies-rules/:id',
        loadChildren: () => import('../cookies-rules/cookies-rules.module').then(m => m.CookiesRulesModule),
        data: {
          seo: {
            title: 'Pravidlá používania cookies | Gryf',
            description: 'Pravidlá používania cookies',
            metaTags: [
              { property: 'og:url', content: 'website' },
              {
                property: 'og:title',
                content: 'Pravidlá používania cookies | Gryf | Reklama na mieru',
              },
              {
                proprety: 'og:description',
                content: 'Pravidlá používania cookies'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'personal-data-for-marketing/:id',
        loadChildren: () => import('../personal-data-for-marketing/personal-data-for-marketing.module').then(m => m.PersonalDataForMarketingModule),
        data: {
          seo: {
            title: 'Súhlas dotknutej osoby so spracúvaním osobných údajov | Gryf',
            description: 'Súhlas dotknutej osoby so spracúvaním osobných údajov',
            metaTags: [
              { property: 'og:url', content: 'website' },
              {
                property: 'og:title',
                content: 'Súhlas dotknutej osoby so spracúvaním osobných údajov | Gryf | Reklama na mieru',
              },
              {
                proprety: 'og:description',
                content: 'Súhlas dotknutej osoby so spracúvaním osobných údajov'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
      {
        path: 'e-offer/:hash',
        loadChildren: () => import('../e-offer/e-offer.module').then(m => m.EOfferModule),
        data: {
          seo: {
            title: 'E-ponuka | Gryf',
            description: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy',
            metaTags: [
              { property: 'og:url', content: 'website' },
              { property: 'og:title', content: 'E-ponuka | Gryf | Reklama, ktorú nevypneš' },
              {
                proprety: 'og:description',
                content: 'Reklamné predmety, potlače, grafika - všetko čo potrebujete pre prezentáciu vašej firmy'
              },
              { property: 'og:image', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
              { property: 'og:image:secure_url', content: environment.apiUrl + 'assets/gryf_meta_image.jpg' },
            ]
          }
        }
      },
    ],
  }
];
